import Error from '../model/Error';
import InvoiceTemplate from '../dto/InvoiceTemplate';
import axios from 'axios';

export default class InvoiceTemplateRepository {

    static findByKindergarten(kindergartenId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/kindergartens/${kindergartenId}/invoice-templates`, {  })
                .then(response => resolve(response.data.data.map(data => InvoiceTemplate.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static update(kindergartenId, invoiceTemplates) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/kindergartens/${kindergartenId}/invoice-templates`, { invoiceTemplates: invoiceTemplates.map(i => i.serialize()) })
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
